import RecycledMaterials from './RecycledMaterials';

export default RecycledMaterials;
